import axios from "axios";

const instance = axios.create({
  baseURL: "https://hr.kzn.ru/api",
  withCredentials: true
});

const SECRET_KEY = 'm9X7vB3zQ2nFp6RtLdVs8JeYWkH1a0Cg';

async function getKey() {
  const enc = new TextEncoder();
  return window.crypto.subtle.importKey(
    'raw',
    enc.encode(SECRET_KEY),
    'AES-GCM',
    false,
    ['encrypt', 'decrypt']
  );
}

async function encrypt(text) {
  const key = await getKey();
  const iv = window.crypto.getRandomValues(new Uint8Array(12));
  const enc = new TextEncoder();
  const encrypted = await window.crypto.subtle.encrypt(
    { name: 'AES-GCM', iv },
    key,
    enc.encode(text)
  );
  const buffer = new Uint8Array(encrypted);
  const fullBuffer = new Uint8Array(iv.length + buffer.length);
  fullBuffer.set(iv);
  fullBuffer.set(buffer, iv.length);
  return btoa(String.fromCharCode(...fullBuffer));
}

async function decrypt(data) {
  const key = await getKey();
  const rawData = Uint8Array.from(atob(data), c => c.charCodeAt(0));
  const iv = rawData.slice(0, 12);
  const encrypted = rawData.slice(12);
  const decrypted = await window.crypto.subtle.decrypt(
    { name: 'AES-GCM', iv },
    key,
    encrypted
  );
  const dec = new TextDecoder();
  return dec.decode(decrypted);
}

async function saveTokens({ access, refresh }) {
  localStorage.setItem("accessToken", access);
    const encrypted = await encrypt(refresh);
  localStorage.setItem("refreshToken", encrypted);
}

async function getRefreshToken() {
  const encrypted = localStorage.getItem("refreshToken");
  if (!encrypted) return null;
  try {
    return await decrypt(encrypted);
  } catch {
    return null;
  }
}

function saveAccessToken(token) {
  localStorage.setItem("accessToken", token);
}

function getAccessToken() {
  return localStorage.getItem("accessToken");
}

instance.interceptors.request.use(
  async (config) => {
    const token = getAccessToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;  
    }
    return config;
  },
  (error) => Promise.reject(error)
);

instance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      const refreshToken = await getRefreshToken();
      if (!refreshToken) {
        // Перенаправление на логин или очистка токенов
        localStorage.removeItem("accessToken");
        localStorage.removeItem("refreshToken");
        window.location.href = "/login";
        return Promise.reject(error);
      }
      try {
        const res = await axios.post("https://hr.kzn.ru/api/token/refresh/", { refresh: refreshToken });
        const { access } = res.data;
        saveAccessToken(access);
        originalRequest.headers.Authorization = `Bearer ${access}`;
        return instance(originalRequest);
      } catch (e) {
        localStorage.removeItem("accessToken");
        localStorage.removeItem("refreshToken");
        window.location.href = "/login";
        return Promise.reject(e);
      }
    }
    return Promise.reject(error);
  }
);

export { saveTokens };
export default instance;
